import { render } from "./LiveTicker.vue?vue&type=template&id=33624e7e"
import script from "./LiveTicker.vue?vue&type=script&lang=js"
export * from "./LiveTicker.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/LiveTicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33624e7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33624e7e', __exports__)) {
    api.reload('33624e7e', __exports__)
  }
  
  module.hot.accept("./LiveTicker.vue?vue&type=template&id=33624e7e", () => {
    api.rerender('33624e7e', render)
  })

}


export default __exports__